/**
 * Zwei-Klick-Consent für das Baroon-AI-Chat-Widget (§ 25 Abs. 1 TDDDG,
 * Art. 6 Abs. 1 lit. a DSGVO).
 *
 * Es gibt bewusst KEINEN seitenweiten Cookie-Banner: Die Einwilligung wird
 * direkt am Widget eingeholt (ChatbotConsentLauncher). Ablehnen speichert
 * nichts — der nächste Klick fragt einfach wieder. Erst die Zustimmung
 * legt den localStorage-Key an; Widerruf über den Footer-Link oder die
 * Datenschutzerklärung entfernt ihn wieder.
 */

const CONSENT_KEY = 'sizilianer-chatbot-consent';
/**
 * Version des Einwilligungstexts. `hasChatbotConsent()` prüft STRIKT auf
 * Gleichheit — eine Erhöhung macht damit automatisch alle Alt-Einwilligungen
 * ungültig, und der Gast bekommt die Karte erneut zu sehen. Genau das ist der
 * Zweck: Wer nur dem alten Text zugestimmt hat, hat dem neuen Umfang nicht
 * zugestimmt.
 *
 * 1 → 2 (Testphase Chat-Verläufe): Der Verarbeitungsumfang ist gewachsen —
 * Chat-Nachrichten und Bot-Antworten werden jetzt befristet bei uns
 * gespeichert (30 Tage), der Seitenverlauf wird erfasst, und nach der
 * Zustimmung wird erstmals ein eigener Cookie (`sz_chat`) gesetzt.
 * Alte Einwilligungen decken das nicht ab und müssen neu eingeholt werden.
 */
export const CONSENT_VERSION = 2;

const SESSION_KEYS = [
  'sizilianer-chatbot-session',
  'sizilianer-chatbot-loaded',
  'sizilianer-chatbot-fi',
];

export function hasChatbotConsent(): boolean {
  try {
    const raw = localStorage.getItem(CONSENT_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw) as { v?: number };
    return parsed?.v === CONSENT_VERSION;
  } catch {
    // Safari Private Mode / Storage aus → wie „nicht erteilt" behandeln.
    return false;
  }
}

export function grantChatbotConsent(): void {
  try {
    localStorage.setItem(
      CONSENT_KEY,
      JSON.stringify({ v: CONSENT_VERSION, ts: new Date().toISOString() }),
    );
  } catch {
    // Ohne Storage gilt die Einwilligung nur für diese Seite — ok.
  }
}

export function revokeChatbotConsent(): void {
  try {
    localStorage.removeItem(CONSENT_KEY);
    for (const key of SESSION_KEYS) sessionStorage.removeItem(key);
  } catch {
    // ignorieren
  }
  // Reload entfernt das bereits geladene Vendor-Script zuverlässig.
  window.location.reload();
}
